import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons';
function Animations() {
    const [loading, setloading] = useState(true)
    const { pathname } = useLocation()
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 1000);
    }, [pathname])
    useEffect(() => {
        const func = () => setloading(false)
        const timeout = setTimeout(() => { setloading(false) }, 7000);
        window.addEventListener("load", func)
        return () => {
            window.removeEventListener("load", func)
            clearTimeout(timeout)
        }
    }, [])

    return (
        <div
            style={{
                position: "fixed",
                width: "100vw",
                height: "100vh",
                left: "0",
                top: "0",
                background: "rgba(0,0,0,.95)",
                display: loading ? "grid" : "none",
                placeContent: "center",
                zIndex: "10000"
            }
            }>
            <LoadingOutlined
                style={{
                    fontSize: 50,
                    color: "white"
                }}
                spin
            />
        </div>
    )
}

export default Animations